import { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

import krevet1 from '../assets/images/krevet1.webp';
import krevet2 from '../assets/images/krevet2.webp';
import krevet3 from '../assets/images/krevet3.webp';
import krevet4 from '../assets/images/krevet4.webp';
import krevet5 from '../assets/images/krevet5.webp';
import krevet6 from '../assets/images/krevet6.webp';
import krevet7 from '../assets/images/krevet7.webp';
import krevet8 from '../assets/images/krevet8.webp';

import kuhinja1 from '../assets/images/kuhinja1.jpg'
import kuhinja2 from '../assets/images/kuhinja2.webp';
import kuhinja3 from '../assets/images/kuhinja3.webp';
import kuhinja4 from '../assets/images/kuhinja4.webp';
import kuhinja5 from '../assets/images/kuhinja5.webp';
import kuhinja6 from '../assets/images/kuhinja6.webp';
import kuhinja7 from '../assets/images/kuhinja7.webp';
import kuhinja8 from '../assets/images/kuhinja8.webp';
import kuhinja9 from '../assets/images/kuhinja9.webp';
import kuhinja10 from '../assets/images/kuhinja10.webp';
import kuhinja11 from '../assets/images/kuhinja11.webp';
import kuhinja12 from '../assets/images/kuhinja12.webp';
import kuhinja13 from '../assets/images/kuhinja13.webp';
import kuhinja14 from '../assets/images/kuhinja14.webp';
import kuhinja15 from '../assets/images/kuhinja15.webp';
import kuhinja16 from '../assets/images/kuhinja16.webp';
import kuhinja17 from '../assets/images/kuhinja17.webp';
import kuhinja18 from '../assets/images/kuhinja18.webp';
import kuhinja19 from '../assets/images/kuhinja19.webp';
import kuhinja20 from '../assets/images/kuhinja20.webp';
import kuhinja21 from '../assets/images/kuhinja21.webp';
import kuhinja22 from '../assets/images/kuhinja22.webp';
import kuhinja23 from '../assets/images/kuhinja23.webp';
import kuhinja24 from '../assets/images/kuhinja24.webp';

import kupaonica1 from '../assets/images/kupaonica1.webp';
import kupaonica2 from '../assets/images/kupaonica2.webp';
import kupaonica3 from '../assets/images/kupaonica3.webp';
import kupaonica4 from '../assets/images/kupaonica4.webp';
import kupaonica5 from '../assets/images/kupaonica5.webp';
import kupaonica6 from '../assets/images/kupaonica6.webp';
import kupaonica7 from '../assets/images/kupaonica7.webp';
import kupaonica8 from '../assets/images/kupaonica8.webp';

import ormar1 from '../assets/images/ormar1.webp';
import ormar2 from '../assets/images/ormar2.webp';
import ormar3 from '../assets/images/ormar3.webp';
import ormar4 from '../assets/images/ormar4.webp';
import ormar5 from '../assets/images/ormar5.webp';
import ormar6 from '../assets/images/ormar6.webp';
import ormar7 from '../assets/images/ormar7.webp';
import ormar8 from '../assets/images/ormar8.webp';
import ormar9 from '../assets/images/ormar9.webp';
import ormar10 from '../assets/images/ormar10.webp';
import ormar11 from '../assets/images/ormar11.webp';
import ormar12 from '../assets/images/ormar12.webp';
import ormar13 from '../assets/images/ormar13.webp';
import ormar14 from '../assets/images/ormar14.webp';
import ormar15 from '../assets/images/ormar15.webp';
import ormar16 from '../assets/images/ormar16.webp';
import ormar17 from '../assets/images/ormar17.webp';
import ormar18 from '../assets/images/ormar18.webp';

import predsoblje1 from '../assets/images/predsoblje1.webp';
import predsoblje2 from '../assets/images/predsoblje2.webp';
import predsoblje3 from '../assets/images/predsoblje3.webp';
import predsoblje4 from '../assets/images/predsoblje4.webp';
import predsoblje5 from '../assets/images/predsoblje5.webp';
import predsoblje6 from '../assets/images/predsoblje6.webp';
import { BentoGrid } from './BentoGrid';

// Mapping from category name to objects type key
const categoryTypeMap: Record<string, string> = {
  'Kuhinja': 'kuhinja',
  'Krevet': 'krevet',
  'Ormar': 'ormar',
  'Predsoblje': 'predsoblje',
  'Kupaonica': 'kupaonica',
};

const objects = [
    { src: krevet1, type: 'krevet' },
    { src: krevet2, type: 'krevet' },
    { src: krevet3, type: 'krevet' },
    { src: krevet4, type: 'krevet' },
    { src: krevet5, type: 'krevet' },
    { src: krevet6, type: 'krevet' },
    { src: krevet7, type: 'krevet' },
    { src: krevet8, type: 'krevet' },
    { src: kuhinja1, type: 'kuhinja' },
    { src: kuhinja2, type: 'kuhinja' },
    { src: kuhinja3, type: 'kuhinja' },
    { src: kuhinja4, type: 'kuhinja' },
    { src: kuhinja5, type: 'kuhinja' },
    { src: kuhinja6, type: 'kuhinja' },
    { src: kuhinja7, type: 'kuhinja' },
    { src: kuhinja8, type: 'kuhinja' },
    { src: kuhinja9, type: 'kuhinja' },
    { src: kuhinja10, type: 'kuhinja' },
    { src: kuhinja11, type: 'kuhinja' },
    { src: kuhinja12, type: 'kuhinja' },
    { src: kuhinja13, type: 'kuhinja' },
    { src: kuhinja14, type: 'kuhinja' },
    { src: kuhinja15, type: 'kuhinja' },
    { src: kuhinja16, type: 'kuhinja' },
    { src: kuhinja17, type: 'kuhinja' },
    { src: kuhinja18, type: 'kuhinja' },
    { src: kuhinja19, type: 'kuhinja' },
    { src: kuhinja20, type: 'kuhinja' },
    { src: kuhinja21, type: 'kuhinja' },
    { src: kuhinja22, type: 'kuhinja' },
    { src: kuhinja23, type: 'kuhinja' },
    { src: kuhinja24, type: 'kuhinja' },
    { src: kupaonica1, type: 'kupaonica' },
    { src: kupaonica2, type: 'kupaonica' },
    { src: kupaonica3, type: 'kupaonica' },
    { src: kupaonica4, type: 'kupaonica' },
    { src: kupaonica5, type: 'kupaonica' },
    { src: kupaonica6, type: 'kupaonica' },
    { src: kupaonica7, type: 'kupaonica' },
    { src: kupaonica8, type: 'kupaonica' },
    { src: ormar1, type: 'ormar' },
    { src: ormar2, type: 'ormar' },
    { src: ormar3, type: 'ormar' },
    { src: ormar4, type: 'ormar' },
    { src: ormar5, type: 'ormar' },
    { src: ormar6, type: 'ormar' },
    { src: ormar7, type: 'ormar' },
    { src: ormar8, type: 'ormar' },
    { src: ormar9, type: 'ormar' },
    { src: ormar10, type: 'ormar' },
    { src: ormar11, type: 'ormar' },
    { src: ormar12, type: 'ormar' },
    { src: ormar13, type: 'ormar' },
    { src: ormar14, type: 'ormar' },
    { src: ormar15, type: 'ormar' },
    { src: ormar16, type: 'ormar' },
    { src: ormar17, type: 'ormar' },
    { src: ormar18, type: 'ormar' },
    { src: predsoblje1, type: 'predsoblje' },
    { src: predsoblje2, type: 'predsoblje' },
    { src: predsoblje3, type: 'predsoblje' },
    { src: predsoblje4, type: 'predsoblje' },
    { src: predsoblje5, type: 'predsoblje' },
    { src: predsoblje6, type: 'predsoblje' },
];

interface ImageItem {
  url: string;
  title: string;
}

interface Category {
  name: string;
  images: ImageItem[];
}

const categories: Category[] = [
  {
    name: 'Kuhinja',
    images: [
      { url: kuhinja1, title: 'Moderna kuhinja' },
      { url: kuhinja2, title: 'Luksuzna kuhinja' },
      { url: kuhinja3, title: 'Kuhinja po mjeri' },
      { url: kuhinja4, title: 'Bijela kuhinja' },
      { url: kuhinja5, title: 'Tamna kuhinja' },
      { url: kuhinja6, title: 'Moderna kuhinja' },
      { url: kuhinja7, title: 'Moderna kuhinja' },
      { url: kuhinja8, title: 'Luksuzna kuhinja' },
      { url: kuhinja9, title: 'Kuhinja po mjeri' },
      { url: kuhinja10, title: 'Bijela kuhinja' },
    ],
  },
  {
    name: 'Krevet',
    images: [
      { url: krevet1, title: 'Elegantan krevet' },
      { url: krevet2, title: 'Moderan krevet' },
      { url: krevet3, title: 'Luksuzna spavaća soba' },
      { url: krevet4, title: 'Skandinavski dizajn' },
      { url: krevet7, title: 'King size krevet' },
    ],
  },
  {
    name: 'Ormar',
    images: [
      { url: ormar1, title: 'Walk-in ormar' },
      { url: ormar2, title: 'Drveni ormar' },
      { url: ormar6, title: 'Moderan ormar' },
      { url: ormar9, title: 'Organiziran ormar' },
      { url: ormar5, title: 'Ugradbeni ormar' },
    ],
  },
  {
    name: 'Predsoblje',
    images: [
      { url: predsoblje1, title: 'Predsoblje namještaj' },
      { url: predsoblje2, title: 'Moderno predsoblje' },
      { url: predsoblje3, title: 'Hodnik dizajn' },
      { url: predsoblje4, title: 'Konzolni stol' },
      { url: predsoblje5, title: 'Konzolni stol' },
    ],
  },
  {
    name: 'Kupaonica',
    images: [
      { url: kupaonica1, title: 'Luksuzna kupaonica' },
      { url: kupaonica2, title: 'Moderna kupaonica' },
      { url: kupaonica3, title: 'Kupaonica po mjeri' },
      { url: kupaonica4, title: 'Umivaonik sa ogledalom' },
      { url: kupaonica5, title: 'Viseći element' },
    ],
  },
];

export function Gallery() {
  const [activeCategory, setActiveCategory] = useState(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);

  // All images for active category from objects array (used in lightbox)
  const activeCategoryType = categoryTypeMap[categories[activeCategory].name];
  const lightboxImages = objects.filter((obj) => obj.type === activeCategoryType);

  const openLightbox = (bentoIndex: number) => {
    // Map the bento grid index to the corresponding image src,
    // then find that image's index in the lightboxImages array
    const clickedSrc = categories[activeCategory].images[bentoIndex]?.url;
    const lightboxIndex = lightboxImages.findIndex((obj) => obj.src === clickedSrc);
    setSelectedImageIndex(lightboxIndex !== -1 ? lightboxIndex : 0);
  };

  const closeLightbox = () => {
    setSelectedImageIndex(null);
  };

  const navigateImage = (direction: 'prev' | 'next') => {
    if (selectedImageIndex === null) return;
    const total = lightboxImages.length;
    if (direction === 'prev') {
      setSelectedImageIndex((prev) => (prev === 0 ? total - 1 : prev! - 1));
    } else {
      setSelectedImageIndex((prev) => (prev === total - 1 ? 0 : prev! + 1));
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'ArrowLeft') navigateImage('prev');
    if (e.key === 'ArrowRight') navigateImage('next');
    if (e.key === 'Escape') closeLightbox();
  };

  const currentImages = categories[activeCategory].images;

  return (
    <section id="galerija" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl mb-6 text-gray-900">Naši radovi</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-12">
            Pogledajte neke od naših najnovijih projekata
          </p>

          {/* Category Tabs */}
          <div className="flex flex-wrap justify-center gap-3 mb-16">
            {categories.map((category, index) => (
              <button
                key={index}
                onClick={() => setActiveCategory(index)}
                className={`px-8 py-2 rounded-full transition-all duration-300 text-lg ${
                  activeCategory === index
                    ? 'bg-yellow-500 text-white shadow-xl scale-105'
                    : 'bg-white text-gray-700 hover:bg-gray-100 shadow-md hover:shadow-lg'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Bento Box Grid Layout — still uses categories (first 5 images) */}
        <BentoGrid
          images={currentImages?.slice(0, 5)}
          openLightbox={openLightbox}
        />
      </div>

      {/* Lightbox Modal — uses objects array filtered by active category */}
      {selectedImageIndex !== null && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center"
          onClick={closeLightbox}
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          {/* Close Button */}
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
            onClick={closeLightbox}
          >
            <X className="w-8 h-8" />
          </button>

          {/* Category Name */}
          <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-white text-xl">
            {categories[activeCategory].name}
          </div>

          {/* Previous Button */}
          <button
            className="absolute left-4 text-white hover:text-gray-300 transition-colors p-2 hover:bg-white/10 rounded-full"
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('prev');
            }}
          >
            <ChevronLeft className="w-12 h-12" />
          </button>

          {/* Image */}
          <div className="max-w-5xl max-h-[80vh] mx-auto px-16" onClick={(e) => e.stopPropagation()}>
            <img
              src={lightboxImages[selectedImageIndex].src}
              alt={`${categories[activeCategory].name} ${selectedImageIndex + 1}`}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
              loading="lazy"
            />
            <p className="text-white/60 text-center mt-2">
              {selectedImageIndex + 1} / {lightboxImages.length}
            </p>
          </div>

          {/* Next Button */}
          <button
            className="absolute right-4 text-white hover:text-gray-300 transition-colors p-2 hover:bg-white/10 rounded-full"
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('next');
            }}
          >
            <ChevronRight className="w-12 h-12" />
          </button>
        </div>
      )}
    </section>
  );
}